module.exports = __webpack_public_path__ + "img/142.0cd2e294.jpg";